import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { TemplateType } from '../../../../core/enums';
import { Resource } from '../../../../core/models';
import { ProcessNavigatorService } from '../../../../core/services/process-navigator.service';

@Component({
  selector: 'kt-workflow-add-process-nav-resource-dialog',
  templateUrl: './workflow-add-process-nav-resource-dialog.component.html',
})
export class WorkflowAddProcessNavResourceDialogComponent implements OnInit {
  TemplateType = TemplateType;
  form: FormGroup;
  emitResources = false;
  resources: Partial<Resource>[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      workflowGroup: string;
      workflows: any[];
    },
    private dialogRef: MatDialogRef<WorkflowAddProcessNavResourceDialogComponent>,
    private formBuilder: FormBuilder,
    private processNavService: ProcessNavigatorService,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({ workflowId: ['', Validators.required] });
  }

  isInvalid(name: string): boolean {
    const field = this.form.get(name);

    return field.touched && field.invalid;
  }

  getErrorMessage(name: string): string {
    return `${name} field is required`;
  }

  updateResources(resources: Partial<Resource>[]): void {
    this.resources = resources;
  }

  cancel(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close(false);
  }

  save(event: Event): void {
    event.stopPropagation();

    this.form.markAllAsTouched();

    if (this.form.invalid) return;

    this.emitResources = true;

    setTimeout(() => {
      this.processNavService
        .createUpdateResources(
          this.form.get('workflowId')?.value,
          TemplateType.WORKFLOW,
          this.resources.filter((resource) => resource.path),
        )
        .pipe(take(1))
        .subscribe((res) => {
          if (!res) return;

          this.dialogRef.close(true);
        });
    });
  }
}
